<template>
  <tr>
    <th v-if="!isDocumentData">
      {{ attribute.description }}
      <span style="opacity: 0.2; font-size: 70%;">
                {{ attribute.label }}
            </span>
      <a-popover placement="topRight" v-if="attribute.explanation.length > 0">
        <template slot="content">
          <div style="max-width: 500px;">
            {{ attribute.explanation }}
          </div>
        </template>
        <a-button class="pull-right" type="link" style="margin: -0.5rem;opacity: 0.5;">
          <help-icon></help-icon>
        </a-button>
      </a-popover>
    </th>
    <td v-if="!isDocumentData">
      {{ value }}
    </td>
    <td v-if="isDocumentData" colspan="2">
      <div class="alert alert-warning static">Het kan voorkomen dat de bijlage te groot is om weer te geven. Downloaden is wel mogelijk.</div>
      <a-button type="primary" v-on:click="onDownload" style="margin-bottom: 1.5rem; margin-top: 1.5rem">Download</a-button>
      <iframe v-if="isDisplayable" style="width: 100%; min-height: 500px;border:0;" :src="dataString"></iframe>
    </td>
  </tr>
</template>

<script>
import {mapGetters} from "vuex";
import store from '../store';
import download from '~/plugins/downloadjs'
import DateFormatEnum from '~/enums/DateFormatEnum';
import moment from 'moment';

export default {
  name: "SiviAttributeComponent",
  props: {
    attribute: {
      type: Object,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      siviMessage: null,
      displayableExtensions: {
        'application/pdf': 'pdf',
        'image/png': 'png',
        'image/jpg': 'jpg',
        'image/jpeg': 'jpeg',
        'image/bpm': 'bmp',
        'text/plain': 'txt',
        'audio/mpeg': 'mp3',
        'video/mp4': 'mp4',
        'video/mpeg': 'mpeg',
      }
    }
  },
  computed: {
    ...mapGetters({
      staticSearches: '$_templating/staticSearches',
    }),
    value() {
      if (this.attribute.codeListDescription !== null) {
        return this.attribute.codeListDescription;
      }
      if (this.isDate) {
        return moment(this.attribute.value.date).format(DateFormatEnum.DISPLAY_DATE);
      }

      return this.attribute.formattedValue;
    },
    isDate() {
      return (typeof this.attribute.value !== 'undefined' && this.attribute.value !== null &&
          typeof this.attribute.value.date !== 'undefined' && this.attribute.value.date !== null);
    },
    isDocumentData() {
      return this.attribute.label === 'DATA';
    },
    isDisplayable() {
      return this.isDocumentData
          && this.extensionAttribute !== null
          && this.dataMimeType !== null;
    },
    dataString() {
      if (this.isDocumentData) {
        return 'data:' + this.dataMimeType + ';base64, ' + this.attribute.value
      }

      return null;
    },
    extensionAttribute() {
      return this.getAttributeByLabel('EXT');
    },
    filenameAttribute() {
      return this.getAttributeByLabel('FILNM') || this.getAttributeByLabel('URLBY');
    },
    dataMimeType() {
      if (this.extensionAttribute !== null) {
        return this.getKeyByValue(this.displayableExtensions, this.extensionAttribute.value.toLowerCase());
      }

      return null;
    }
  },
  created() {
    const STORE_KEY = '$_search';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {},
  components: {},
  methods: {
    getAttributeByLabel(label) {
      return this.entity.attributes.filter(attribute => attribute.label === label)[0];
    },
    getKeyByValue(object, value) {
      return Object.keys(object).find(key => object[key] === value);
    },
    onDownload() {
      download(this.dataString, this.filenameAttribute.value, this.dataMimeType)
    }
  },
}
</script>

<style scoped>
.csv-export-component {
}

table.table th, table.table td {
  padding: 1.5rem 1rem;
}
</style>
